import { api } from '@/lib/api';

export interface QboInvoice {
  id: string;
  docNumber: string;
  date: string;
  dueDate: string;
  total: number;
  balance: number;
  paid: number;
  status: 'Open' | 'Partial' | 'Paid';
  customerId: string;
  customerName: string;
  memo: string;
  currency: string;
  createdAt: string;
  updatedAt: string;
}

export interface QboInvoicesResponse {
  invoices: QboInvoice[];
  count: number;
  totals: { total: number; balance: number; paid: number };
}

export async function fetchQboInvoices(params: {
  start?: string;
  end?: string;
  status?: 'open' | 'paid' | 'overdue';
} = {}): Promise<QboInvoicesResponse> {
  return api.get<QboInvoicesResponse>('/v4/quickbooks', params);
}
